import React, { Component, useEffect, useState } from 'react';
import AddAddressesView from './AddAddressesView'
import crmservices from '../../wsclient/crmservices';
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import AddressesMap from './AddressesMap';
import {address_types} from '../../../portal.config'
import { da } from 'date-fns/locale';
function AddAdresses(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [address_info, setAddressInfo] = useState({});
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [openAddressesMap, setOpenAddressesMap] = useState(false);
    const [isSelected, setIsSelected] = useState(false);
    useEffect(()=>{
        loadAddress();
    },[])

    const loadAddress = () =>{
        var address = props.address;
        //console.log("AddAdresses address:", address);
        if (address) {
            if (address.country_code && address.country_code === 'CYP')
                address.country_code = 'CY'
            setAddressInfo(address)    
        }
    }

    const onSaveAddress = async(values) =>{
        //console.log("onSaveAddress values:", values);
        var new_address_info = {...address_info}
        //
        new_address_info.address_line_1 = values.address_line_1

        if(!new_address_info.address_type){
            new_address_info.address_type = address_types[0].value
        }
        if(values.postal_code){
            new_address_info.postal_code = values.postal_code
        }
        if(values.address_name){
            new_address_info.address_name = values.address_name
        }
        //console.log("onSaveAddress address_info:", address_info);
            onShowLoading(true)
            try {
                var country_code = new_address_info.country_code === 'CY' ? 'CYP' : new_address_info.country_code;
                var result = await crmservices.contacts.addAddress({ ...new_address_info, country_code: country_code });
               // console.log("result:", result);
                if (result.code === 'OK') {
                    props.onLoadAddresses();
                    showAlert(t('SUCCESS'), t('ADD_ADDRESS_SUCCESS'));
                    props.onClose()
                } else if (result.code === 'ADD_ADDRESS_ALREADY_TYPE') {
                    showAlert(t('SUCCESS'), t('ADD_ADDRESS_ALREADY_TYPE'));
                } else {
                    showAlert(t('ERROR'), t('FAILED_TO_ADD_ADDRESS'))
                }
            } catch (error) {
                console.log("add address exception:", error);
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'))
            };
            onShowLoading(false)
    }
    const onUpdateAddress = async(values) => {
        var new_address_info = {...address_info}

        new_address_info.address_line_1 = values.address_line_1
        new_address_info.postal_code = values.postal_code
        new_address_info.address_name = values.address_name
        console.log(' onUpdateAddress address_info===',values)
            onShowLoading(true);
            try {
                var country_code = new_address_info.country_code === 'CY' ? 'CYP' : new_address_info.country_code;
                var result = await crmservices.contacts.updateAddress({ ...new_address_info, country_code: country_code },new_address_info.id);
                console.log("result:", result);
                if (result.code === 'OK') {
                    props.onLoadAddresses();
                    showAlert(t('SUCCESS'), t('UPDATE_ADDRESS_SUCCESS'));
                    props.onClose()
                } else if (result.code === 'ADD_ADDRESS_ALREADY_TYPE') {
                    showAlert(t('ERROR'), t('ADD_ADDRESS_ALREADY_TYPE'))
                } else {
                    showAlert(t('ERROR'), t('FAILED_TO_UPDATE_ADDRESS'))
                }
            } catch (error) {
                console.log("update address exception:", error);
                showAlert(t('ERROR'), t('EXCEPTION_PROCESS'))
            };
            onShowLoading(false)
    }
    const onCloseAddressesMap = (data) =>{
        setOpenAddressesMap(false)
            if (data) {
                if(data.country_code&&data.country_code==='CYP'){
                    data.country_code='CY'
                }

                var country_code = data.country_code;
                //console.log("AAAAAAAAAAAAAAAAA address_info:",address_info);
                //console.log("AAAAAAAAAAAAAAAAA data=",data);

                data.address_type = address_info.address_type;
                data.is_primary = address_info.is_primary;
                data.care_of = address_info.care_of;
                data.address_line_2 = address_info.address_line_2;
                data.address_name = address_info.address_name;

                //console.log("AAAAAAAAAAAAAAAAA data2=",data);
                if(address_info.id){
                    data.id = address_info.id;
                }
                if (country_code) {
                    if (country_code == 'CYP' || country_code === 'CY'){
                        setAddressInfo(data);
                        setIsSelected(true);
                    }
                    else {
                        showAlert(true, 'We are not supported in your region' )
                    }
                } else {
                    setAddressInfo(data)
                    setIsSelected(true)
                }
            }
    }
    const onChangeIsPrimary = () =>{
        setAddressInfo(prevState=>({
            ...prevState,
            is_primary: !address_info.is_primary
        }))
    }
    const onSelectTypeAddress = (type, event) =>{
        setAddressInfo(prevState=>({
            ...prevState,
            [type]: event.target.value
        }))
    }

    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = () =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        })
    }

    const onSelectAddress = () =>{
        setOpenAddressesMap(true);
    }
        
    return (
        <div>
            <AddAddressesView
                showLoading = {showLoading} 
                open = {props.open}
                onClose = {props.onClose}
                onSubmit ={props.mode==='add'?onSaveAddress:onUpdateAddress}
                address_info = {address_info}
                onSelectTypeAddress = {onSelectTypeAddress}
                mode = {props.mode}
                onChangeIsPrimary = {onChangeIsPrimary}
                onSelectAddress = {onSelectAddress}
                isSelected = {isSelected}/>
            {openAddressesMap&&<AddressesMap
                open = {openAddressesMap}
                onClose = {onCloseAddressesMap}
                />} 
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
        </div>
    );
}

export default AddAdresses;